import styles from './CompletedButton.module.scss';
import { showCheckmarkInCircleIcon } from '../../core/core';

const CompletedButton = ({ small, disabled, ...otherProps }) => (
  <div className={styles.completedButton}>
    <button type='button' disabled={disabled} {...otherProps}>
      {showCheckmarkInCircleIcon()} Completed
    </button>
  </div>
);

export default CompletedButton;
